import { useEffect, useState } from 'react';

export const useArtworkCounter = (active) => {
  const [value, setValue] = useState(10);
  useEffect(() => {
    if (!active) { setValue(10); return undefined; }
    const start = performance.now(); let frame;
    const tick = (now) => {
      const progress = Math.min(1, (now - start) / 1400);
      setValue(Math.round(10 + 990 * (1 - (1 - progress) ** 3)));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [active]);
  return value;
};